import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Currency, LazyImage, SvgIcon } from '@teko/ui';
import { PromotionType } from '../../types.es.js';
import { SelectOption } from '../../Common/SelectOption/SelectOption.es.js';
import { PromotionInfo } from './PromotionInfo/PromotionInfo.es.js';

const Quantity = styled.span`
  font-size: 0.75rem;
  color: #848788;
  margin-right: 4px;
`;
const Content = styled.div`
  display: flex;
  justify-content: space-around;
`;
const Benefit = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const Expired = styled.div`
  font-size: 0.75rem;
  color: #f78212;
  margin-left: 8px;
  display: flex;
  align-items: flex-end;
  margin-bottom: 6px;
`;
const Label = styled.div`
  font-size: 0.75rem;
  color: #333333;
  flex: 1;
`;
const Coupon = styled.div`
  text-transform: uppercase;
  padding: 0 6px;
  margin: 0 4px;
  background-color: #ef2741;
  color: #fff;
  border-radius: 2px;
  display: inline-block;
`;
const GiftImage = styled.div`
  width: 10%;
  margin-right: 12px;
`;
const Discount = styled(Currency)`
  color: #ed2101;
  margin-left: 4px;
`;
const StyledPrice = styled(Discount)`
  font-weight: bold;
`;
const PriceWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
const GiftWrapper = styled(PriceWrapper)`
  margin-top: 8px;
`;
const PromotionIcon = styled.div`
  width: 10%;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  border: 1px solid #e0e0e0;
  margin-right: 12px;
`;
const Price = styled.strong`
  color: #ed2101;
`;
const Promotion = ({
  promotion,
  className,
  active = false,
  onClick
}) => {
  var _a, _b;
  return /* @__PURE__ */ React.createElement(SelectOption, {
    isActive: active,
    activeBackground: "rgba(20, 53, 195, 0.08)",
    onClickOption: () => onClick(promotion.id),
    className
  }, /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(Benefit, null, promotion.price && /* @__PURE__ */ React.createElement(PriceWrapper, null, /* @__PURE__ */ React.createElement(Price, null, t("Gi\xE1:")), " ", /* @__PURE__ */ React.createElement(StyledPrice, {
    value: promotion.price
  })), promotion.type === PromotionType.PRODUCT ? /* @__PURE__ */ React.createElement(React.Fragment, null, promotion.benefit.money && !!promotion.benefit.money && promotion.benefit.money.map((moneyPromotion) => /* @__PURE__ */ React.createElement(Label, {
    key: moneyPromotion.id
  }, t("\u0110\xE3 gi\u1EA3m th\xEAm"), /* @__PURE__ */ React.createElement(Discount, {
    value: moneyPromotion.money || 0
  }))), promotion.benefit.items && !!promotion.benefit.items && promotion.benefit.items.map((gift) => {
    var _a2;
    return /* @__PURE__ */ React.createElement(GiftWrapper, {
      key: gift.name
    }, /* @__PURE__ */ React.createElement(GiftImage, null, /* @__PURE__ */ React.createElement(LazyImage, {
      borderRadius: 2,
      contain: true,
      src: ((_a2 = gift.image) == null ? void 0 : _a2.src) || ""
    })), /* @__PURE__ */ React.createElement(Quantity, null, "x", gift.quantity), /* @__PURE__ */ React.createElement(Label, null, gift.name));
  })) : /* @__PURE__ */ React.createElement(GiftWrapper, null, /* @__PURE__ */ React.createElement(PromotionIcon, null, /* @__PURE__ */ React.createElement(SvgIcon, {
    name: "promotion",
    size: 16,
    color: "#1435c3"
  })), /* @__PURE__ */ React.createElement(Label, null, t("\u0110\xE3 \xE1p d\u1EE5ng m\xE3 gi\u1EA3m gi\xE1"), /* @__PURE__ */ React.createElement(Coupon, null, " ", ((_a = promotion.condition) == null ? void 0 : _a.coupon) || "", " "), t("gi\u1EA3m"), /* @__PURE__ */ React.createElement(PromotionInfo, {
    money: (_b = promotion.benefit.money) == null ? void 0 : _b[0],
    condition: promotion.condition || null
  })))), promotion.remainingTime && /* @__PURE__ */ React.createElement(Expired, null, t("Ch\u1EC9 c\xF2n"), " ", promotion.remainingTime)));
};

export { Promotion };
